const personnes = [
   {
       name :"Catherine GUYON",
       fonction : "Responsable et référente formation GHT Rouen Coeur de Seine",
       phone : "02 32 88 80 85 / poste 68 085",
       mail : "catherine.guyon@chu-rouen.fr",
       picture : "catherine_guyon.jpg",
       right : "600px"
   },
   {
       name :"Cettina DAUPHIN",
       fonction : "Assistante de formation",
       phone : "02 32 88 84 65 / poste 68 465",
       mail : "cettina.dauphin@chu-rouen.fr",
       picture : "cettina_dauphin.jpg",
       left : "600px"
   },
   {
       name :"Romain DEVIS",
       fonction : "Assistant de formation",
       phone : "02 32 88 85 92 / poste 68 592",
       mail : "romain.devis@chu-rouen.fr",
       picture : "romain_devis.jpg",
       right : "600px"
   },
   {
       name :"Nathalie COTTARD",
       fonction : "Assistante de formation",
       phone : "02 32 88 68 36 / poste 66 836",
       mail : "nathalie.cottard@chu-rouen.fr",
       picture : "nathalie_cottard.jpg",
       left : "600px"
   },
   {
       name :"Christelle HAMEL",
       fonction : "Assistante de formation",
       phone : "02 32 88 82 13 / poste 68 213",
       mail : "christelle.hamel@chu-rouen.fr",
       picture : "christelle_hamel.jpg",
       right : "600px"
   },
   {
       name :"Sandrine LESPRESLE",
       fonction : "Assistante de formation",
       phone : "02 32 88 58 71 / poste 65 871",
       mail : "sandrine.lespresle@chu-rouen.fr",
       picture : "sandrine_lespresle.jpg",
       left : "600px"
   },
   {
       name :"Hélène ROUAS ANGIBAULT",
       fonction : "Assistante de formation",
       phone : "02 32 88 14 64 / poste 61 464",
       mail : "helene.rouas@chu-rouen.fr",
       picture : "helene_rouas_angibault.jpg",
       right : "600px"
   },
   {
       name :"Thomas LEGRIX",
       fonction : "Adjoint - référent GPMC",
       phone : "02 32 88 39 50 / poste 63 950",
       mail : "thomas.legrix@chu-rouen.fr",
       picture : "thomas_legrix.jpg",
       left : "600px"
   },
   {
       name :"Kelly BERNAL",
       fonction : "Gestionnaire RH études promotionnelles",
       phone : "02 32 88 13 28 / poste 61 328",
       mail : "kelly.bernal@chu-rouen.fr",
       picture : "kelly_bernal.jpg",
       right : "600px"
   },
]

export default personnes;